import size from '../../../../utills/size'
import {pxToRem} from '../../../../utills/pxToRem'
import {fonts} from '../../../../theme/foundations/fonts'

export const brandCategoryStyles = {
    '.landing-section__heading': {
        color: 'black',
        display: 'block',
        fontFamily: fonts.primary,
        fontSize: pxToRem(20),
        fontWeight: 700,
        height: pxToRem(30),
        letterSpacing: pxToRem(2),
        lineHeight: pxToRem(30),
        textAlign: 'center',
        marginBottom: pxToRem(20),
        [`@media (min-width: ${size.md})`]: {
            fontSize: pxToRem(32),
            marginBottom: pxToRem(40),
            marginTop: pxToRem(60)
        }
    },

    '.category-slider': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        columnGap: pxToRem(10),
        [`@media (min-width: ${size.md})`]: {
            columnGap: pxToRem(30)
        },

        '.category-slider__slide': {
            img: {
                height: pxToRem(133),
                width: pxToRem(133),
                [`@media (min-width: ${size.md})`]: {
                    height: pxToRem(266),
                    width: pxToRem(266)
                }
            },

            h3: {
                color: 'black',
                cursor: 'pointer',
                display: 'block',
                fontFamily: fonts.primary,
                fontSize: pxToRem(14),
                fontWeight: 600,
                height: pxToRem(18),
                letterSpacing: pxToRem(1),
                lineHeight: pxToRem(18),
                textAlign: 'center',
                margin: `${pxToRem(20)} 0`,
                [`@media (min-width: ${size.md})`]: {
                    fontSize: pxToRem(18),
                    margin: `${pxToRem(30)} 0`
                },
                _hover: {
                    color: 'cav_red'
                }
            }
        }
    }
}
